import React, {useEffect, useState} from "react";
import ReactSeamlessScroll from "react-seamless-scroll";
import "../style/table.css";

const TablePlay = (props) => {
  const { subData } = props;
  return (
    <tr>
      <td className="rank">
        <p>
          <span>{subData.rank}</span>
        </p>
      </td>
      <td>{subData.number}</td>
      <td>{subData.name}</td>
      <td>{subData.totalSubScore}</td>
      <td>{subData.company}</td>
      {/* <marquee behavior="scroll"><td>{subData.company}</td></marquee> */}
    </tr>
  );
};

const Broadcast = React.memo((props) => {
  const { playData } = props

  // if(playData && playData.length > 5 && playData.length < 10){
  //   playData.push(...playData.slice(3))
  //   playData.push(...playData.slice(3))
  //   return playData
  // }
  const fun = (playData) => {
      if(!playData) return
      if(playData && playData.length > 5 && playData.length < 10){
        playData.push(...playData.slice(3))
        playData.push(...playData.slice(3))
      }
      return playData
    }

  let [data, setData] = useState([])
    useEffect(()=>{
      if (!playData) return
      setData(fun(playData))
  })
  
  return (
    <ReactSeamlessScroll>
      <table className="table-play">
        <tbody>
          {
            //   (playData || []).slice(3).map((item) => (
            //   <TablePlay subData={item} key={playData.length+Math.random()} />
            // ))
              data && data.slice(3).map((item) => (
              <TablePlay subData={item} key={data.length+Math.random()} />
            ))
          }
        </tbody>
      </table>
    </ReactSeamlessScroll>
  );
});

export default Broadcast;
